// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"AwardPage_toolbar__1oK5B","buttons":"AwardPage_buttons__T_ekz","save":"AwardPage_save__1auGr","delete":"AwardPage_delete__ABpXV","back":"AwardPage_back__2Cq4V"};